// Web, software, languages & QA pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const CUSTOM_SOFTWARE_META_DATA: PageHeadMeta = {
    title: 'Custom Software Development Services | Debut Infotech',
    img: cdnUrl('custom-software-development-company/custom-software-development-company.jpg'),
    description:
        'Full-cycle custom software development services for enterprises and startups. AI-integrated, compliance-ready, delivered in production across 20+ countries. Get a free consultation.'
};

export const WEB_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'Web Development Company | Web App Development Services',
    img: cdnUrl('web-development/Web-Application-Development-company.jpg'),
    description:
        'Expert web development company offering custom web app development services. Scalable, secure, and high-performance solutions tailored to your business needs.'
};

export const SOFTWARE_TESTING_META_DATA: PageHeadMeta = {
    title: 'Software Testing and Quality Assurance Services | QA Software Testing',
    img: cdnUrl('meta-images/software-testing-banner.jpg'),
    description: `Streamline your software's performance with our complete software testing and quality assurance services. Boost your software quality today.`
};

export const MANUAL_TESTING_META_DATA: PageHeadMeta = {
    title: 'Manual Testing Services | Manual Software Testing Company',
    img: cdnUrl('meta-images/manual-qa-testing-banner.jpg'),
    description: `Debut Infotech offers top-notch manual testing services to ensure your software's quality, functionality, and reliability. Contact us today!`
};

export const AUTOMATION_TESTING_META_DATA: PageHeadMeta = {
    title: 'QA Automation Testing Services | Automation Testing Services',
    img: cdnUrl('meta-images/automation-testing-banner.jpg'),
    description: `At Debut Infotech, we offer advanced automation testing services to elevate software quality. Contact us now for expert QA solutions for your projects.`
};

export const LARAVEL_META_DATA: PageHeadMeta = {
    title: 'Laravel Web Development Company | Laravel Development Services',
    img: cdnUrl('laravel/Laravel-Development-Company.jpg'),
    description:
        'Hire a top Laravel web development company offering custom Laravel development services for scalable, secure, and high-performing web applications.'
};

export const PHP_META_DATA: PageHeadMeta = {
    title: 'PHP Web Development Company | PHP Web Development Services',
    img: cdnUrl('php/Php-development-company.jpg'),
    description:
        'Get robust, scalable solutions from our leading PHP website development company. We deliver custom PHP web development services to elevate your online business.'
};

export const NODE_META_DATA: PageHeadMeta = {
    title: 'Node.js Development Company | Node.js Development Services',
    img: cdnUrl('nodejs/Nodejs-Development-Company.jpg'),
    description:
        'Hire a top Node.js development company offering scalable, high-performance Node.js development services for web and mobile applications.'
};

export const REACT_META_DATA: PageHeadMeta = {
    title: 'ReactJS Development Company | ReactJS Development Services',
    img: cdnUrl('react-images/ReactJS-Development-Company.jpg'),
    description:
        'Hire a top ReactJS development company for scalable, high-performance web apps. We offer expert ReactJS development services tailored to your business needs.'
};

export const PYTHON_META_DATA: PageHeadMeta = {
    title: 'Python Development Company | Python Development Services',
    img: cdnUrl('python-images/Python-Development-Services.jpg'),
    description:
        'Hire a leading Python development company for scalable, secure, and high-performance Python development services and solutions for your business.'
};

export const DEVOPS_META_DATA: PageHeadMeta = {
    title: 'DevOps Consulting Services and Solutions | Devops Consulting Company',
    description:
        'Looking for the best DevOps Consultant? Accelerate your software development lifecycle with our DevOps as a Service for continuous innovation and growth.',
    img: cdnUrl('meta-images/rightbanner.jpg')
};

export const SAAS_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'SaaS Development Services | Custom Scalable SaaS Solutions',
    description:
        'Build scalable SaaS platforms with expert SaaS development services. Secure, cloud-based, and AI-powered solutions by Debut Infotech for global businesses.',
    img: cdnUrl('Saas-Development/SaaS-Development-Company.jpg')
};

export const ENTERPRISE_SOFTWARE_DEVELOPMENT: PageHeadMeta = {
    title: 'Enterprise Software Development Services',
    description:
        'Unlock business growth with our top-tier Enterprise Software Development Services. Hire expert software developers for scalable, secure, and customized solutions.',
    img: cdnUrl('Enterprise-Software/Enterprise-Software-Development-Services.jpg')
};

export const API_DEVELOPMENT_SERVICES: PageHeadMeta = {
    title: 'API Development Services',
    description:
        'From web to mobile and cloud, our API development services enable secure, scalable system connections to boost agility and accelerate time to value.',
    img: cdnUrl('APi-development/API-Development-Services.jpg')
};

export const JAVA_DEVELOPMENT_SERVICES: PageHeadMeta = {
    title: 'Java Development Company | Java Development Services',
    description:
        'Get scalable and secure Java development services from a leading Java development company. We build custom web, mobile, and enterprise Java applications.',
    img: cdnUrl('Java-development/Java-development-company.jpg')
};

export const DATA_ENGINEERING_SERVICES_META_DATA: PageHeadMeta = {
    title: 'Data engineering Company | Data engineering Services',
    img: cdnUrl('Data-Engineering-Services/Data-Engineering-Services.jpg'),
    description:
        'Debut Infotech, a leading Data Engineering company, delivers scalable data engineering services with pipelines, analytics, and cloud solutions for enterprises.'
};

export const FULL_STACK_WEB_DEVELOPMENT: PageHeadMeta = {
    title: 'Full Stack Development Company | Debut Infotech',
    description:
        'Debut Infotech provides full stack web development services for secure, scalable web applications, SaaS platforms, APIs, cloud, and enterprise systems.',
    img: cdnUrl('Full-Stack-Web Development-Services/Full-Stack-Web-Development-Services.jpg')
};

export const CUSTOM_CMS_DEVELOPMENT_SERVICES: PageHeadMeta = {
    title: 'Custom CMS Development Services and Solutions',
    description:
        'Get custom CMS development services to build secure, scalable, and easy-to-manage websites with flexible features, integrations, and fast growth today!',
    img: cdnUrl('Custom-cms-development-services/Custom-CMS-Development.jpg')
};

export const SOFTWARE_DEVELOPMENT_CONSULTING: PageHeadMeta = {
    title: 'Software Development Consulting Company | Debut Infotech ',
    description:
        'Get expert software consulting services to define your product strategy, modernize legacy systems, choose the right technology, and build scalable solutions.',
    img: cdnUrl('Software-Development-Consulting-Services/Software-Development-Consulting-Services.jpg')
};

export const IT_OUTSOURCING_SERVICES: PageHeadMeta = {
    title: 'End-to-End IT Outsourcing Services',
    img: cdnUrl('IT-outsourcing-services/IT-Outsourcing-Services.jpg'),
    description:
        'Get end-to-end IT outsourcing services to manage development, support, and operations while reducing costs and enabling secure, scalable business growth.'
};

export const PRICING_MODELS: PageHeadMeta = {
    title: 'Software Engagement & Pricing Models | Debut Infotech',
    description:
        'Explore flexible pricing models tailored to your project needs across Product Engineering, AI services, and dedicated team engagements at Debut Infotech.',
    img: cdnUrl('Software-Development-Consulting-Services/Software-Development-Consulting-Services.jpg')
};
